import { render } from "./acordeon.vue?vue&type=template&id=43348e2f"
import script from "./acordeon.vue?vue&type=script&lang=js"
export * from "./acordeon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__